import { render, staticRenderFns } from "./delAgentModal.vue?vue&type=template&id=a4bb2a08&scoped=true&"
import script from "./delAgentModal.vue?vue&type=script&lang=js&"
export * from "./delAgentModal.vue?vue&type=script&lang=js&"
import style0 from "./delAgentModal.vue?vue&type=style&index=0&id=a4bb2a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb2a08",
  null
  
)

export default component.exports